// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-content {\n  display: flex;\n  background: whitesmoke;\n}\n.main-content .left-content-main {\n  flex: 1;\n  margin-left: 15px;\n}\n.main-content .right-content {\n  flex: 3;\n}\n\n.table-height {\n  height: calc(100vh - 140px);\n  overflow: auto;\n}\n\n.no-item-text {\n  height: 76%;\n  position: fixed;\n  justify-content: center;\n  display: flex;\n  width: 66%;\n  align-items: center;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
